import { parseDomain } from '@wix/domains-serverless-interface';
import React from 'react';
import { MobileDomainTaken } from './MobileDomainTaken';
import { MobileSubdomainRootTaken } from './MobileSubdomainRootTaken';
export const MobileUpgradeRequireConnect = props => {
  const _parseDomain = parseDomain(props.domainName ?? ''),
    subdomain = _parseDomain.subdomain;
  return subdomain ? /*#__PURE__*/React.createElement(MobileSubdomainRootTaken, props) : /*#__PURE__*/React.createElement(MobileDomainTaken, props);
};
//# sourceMappingURL=MobileUpgradeRequireConnect.js.map